import React from "react";
import { range } from "../../../../utilities/generators";
import { Checkbox, FormControlLabel, FormGroup, Grid } from "@mui/material";
import PropTypes from "prop-types";

function RepeatPattern({ pattern = [], setPattern, maxCycles }) {
    if (maxCycles < 2) return null;

    const cycles = range(1, maxCycles);
    const handleCheckbox = (event, checked) => {
        const value = Number(event.target.value);
        if (checked) {
            if (!pattern.includes(value)) setPattern([...pattern, value]);
        } else {
            if (pattern.includes(value)) setPattern(pattern.filter(v => v !== value));
        }
    }

    return (
        <Grid item xs={12} sm={12} md={12}>
            <FormGroup aria-label="position" row>
                {cycles.map((option) => (
                    <FormControlLabel
                        key={option}
                        control={<Checkbox value={option} checked={pattern.includes(option)} onChange={handleCheckbox}/>}
                        label={option}
                    />
                ))}
            </FormGroup>
        </Grid>
    )

}

RepeatPattern.propTypes = {
    maxCycles: PropTypes.number,
    pattern: PropTypes.arrayOf(PropTypes.number),
    setPattern: PropTypes.func.isRequired
}

export default RepeatPattern;
